import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const TitleBlock = styled.div`
  padding: 10px 25px;
  max-width: ${themeGet('document.maxWidth')};
  margin: 73px auto 0 auto; /*altered top padding to reflect Customer Support design */
  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    margin: 72px 0 auto 0;
    padding: 10px 1rem;
    &.title_media-section-3-deep {
      margin-top: 0;
    }
  }
`;

export const StyledTitle = styled.h1`
  font-size: 2.8125rem;
  line-height: 3.4375rem;
`;
